module.exports = __webpack_public_path__ + "img/dubi.ebc0b2a9.svg";